import React from 'react'
import { useSelector } from 'react-redux'
import Day from './Day'

const Week = (props: any) => {
  let { events, date, squadsEvents, showSquadsEvent, selected, select } = props
  let days = []
  const daysState = useSelector((state: { calendars: any }) => state.calendars)

  for (var i = 0; i < 7; i++) {
    if (daysState.length > 0) {
      let dayData = daysState.filter((x: any) => x.day.date.isSame(date) === true)[0]
      days.push(
        <Day
          key={dayData.day.date.toString()}
          day={dayData.day}
          event={dayData.event}
          events={events}
          squadsEvents={squadsEvents}
          showSquadsEvent={showSquadsEvent}
          selected={selected}
          select={select}
        />
      )
    }
    date = date.clone()
    date.add(1, 'day')
  }

  const WeekComponent: React.FC<any> = ({ days }) => {
    return (
      <div className="row week" key={days[0]}>
        {days}
      </div>
    )
  }

  return (
    <>
      <WeekComponent key={days[0]} days={days}></WeekComponent>
    </>
  )
}

export default Week
